import * as React from 'react'
import ReactDOM from 'react-dom'

import GlobalNav from './GlobalNav'
import * as GlobalNavData from './GlobalNav'
import * as models from './models'
import {GlobalNavConfOptions, GlobalNavLoaderType} from "./suite/common"

declare global {
    interface Window {
      attachEvent: any
      GLOBAL_NAV: typeof GlobalNavObject
    }
}

const GlobalNavObject: GlobalNavLoaderType = {
  data: { ...models, ...GlobalNavData },
  render: function (configuration: GlobalNavConfOptions) {
    const {
      onUpdate = void 0,
      elementId = 'q4m_global_nav_container',
      currentApp = GlobalNavData.Application.AdsManager
    } = configuration || {}
    const globalNavBarContainer = document.getElementById(elementId) || document.createElement('div')
    const props: GlobalNavData.GlobalNavProps = { currentApp }

    globalNavBarContainer.id = elementId
    if (onUpdate) {
      props.onUpdate = onUpdate
    }
    if (configuration.accountInfo) {
      props.accountInfo = configuration.accountInfo
    }

    ReactDOM.unmountComponentAtNode(globalNavBarContainer)
    ReactDOM.render(<GlobalNav {...props} />, globalNavBarContainer)

    if (!configuration || !configuration.elementId) {
      document.body.insertBefore(globalNavBarContainer, document.body.firstElementChild)
    }
  }
}
window.GLOBAL_NAV = GlobalNavObject

export * from './models'
export * from './GlobalNav'
export default GlobalNav
